"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueHeader = void 0;
var GaiaScalars_1 = require("../graphql/GaiaScalars");
var QueueHeader = /** @class */ (function () {
    function QueueHeader(identityId, channelId) {
        if (channelId === void 0) { channelId = GaiaScalars_1.UUID.randomUUID().toString(); }
        this.identityId = identityId;
        this.channelId = channelId;
    }
    QueueHeader.getChannelIdFromTopic = function (topic) {
        var split = topic.split('/');
        return split[split.length - 2];
    };
    return QueueHeader;
}());
exports.QueueHeader = QueueHeader;
//# sourceMappingURL=QueueHeader.js.map